export class Modelo {
  ativo: boolean;
  id: number;
  consumoEsperadoMaximo: number;
  consumoEsperadoMinimo: number;
  formaControleId: number;
  modelo: string;
  motorizado: boolean;
  numeroEixos: number;
  marcaId: number;
  tipoBemId: number;
  subTipoBemId: number;
  tipoDeslocamentoId: number;
  categoriaExigidaId: number;
  potencia: number;
  cilindradas: number;
  consumoMedio: number;
  numeroPassageiros: number;
  capacidadeCarga: number;
  capacidadeTanque: number;
  tipoEixo: string;
}
  



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/shared/modelo.model.ts
 **/